export default "__VITE_PUBLIC_ASSET__db295399__"